export default '$$material';


// WEBPACK FOOTER //
// ./node_modules/@mui/material/styles/identifier.js